import { PaymentTabsEnum } from '../../../enums/payment-tabs-enum';
import { rootActions, useAppDispatch, useAppSelector } from '../../../data/store';
import { saveToStorage } from '../../../../../../DAL/storage-provider';
import { checkIsSubscription, SELECTED_PAYMENT_TAB_STORAGE_KEY } from '../../../domain/shopping-cart-provider';
import { sendGAEvent } from '../../../../../../domain/marketing/gtm-provider';
import { ICartData } from '../../../interfaces';
import { getIsChina } from '../../../../../../domain/hidden-data-provider';
import {
    getGoogleAnalyticsTitleByPaymentType,
    getIconByType,
    paymentTabSelectedStyles
} from '../../../../cart-shared-bridger-pay/domain/payment-tabs-provider';

interface IPaymentTabProps {
    type: PaymentTabsEnum;
    title: string;
    isLast: boolean;
}

export const getSelectedTab = (
    cartData: ICartData,
    selectedPaymentTab: PaymentTabsEnum
) : PaymentTabsEnum => {

    const isSubscription = checkIsSubscription(cartData);
    const isChina = getIsChina();

    if(isChina && (
        selectedPaymentTab === PaymentTabsEnum.PayPal ||
        selectedPaymentTab === PaymentTabsEnum.ApplePay
    )) {
        // No PayPal and no ApplePay in China.
        return PaymentTabsEnum.CreditCard;
    }

    if((isSubscription && (selectedPaymentTab === PaymentTabsEnum.AliPay))){
        // No subscription with AliPay
        return PaymentTabsEnum.CreditCard;
    }

    return selectedPaymentTab;
};

const PaymentTab = ({ type, title, isLast }: IPaymentTabProps) => {

    const dispatch = useAppDispatch();

    const cartData = useAppSelector(store => store.root.cartData);
    const selectedPaymentTab = useAppSelector(store => store.root.selectedPaymentTab);

    const isTabSelected = getSelectedTab(cartData, selectedPaymentTab) === type;
    const Icon = getIconByType(type);

    const onClick = () => {
        dispatch(
            rootActions.main({
                selectedPaymentTab: type,
            })
        );

        saveToStorage('session-storage', SELECTED_PAYMENT_TAB_STORAGE_KEY, type);
        sendGAEvent('Payment Method', getGoogleAnalyticsTitleByPaymentType(type));
    };

    return (
        <button
            type="button"
            className={`px-1 py-8 flex flex-col items-center justify-center text-center ${ !isLast && !isTabSelected ? 'border-r' : '' }`}
            style={ isTabSelected ? paymentTabSelectedStyles : undefined }
            onClick={ onClick }>
            <div className="mb-2">
                <Icon
                    width="20px"
                    color={ isTabSelected ? '#3452ff' : '#1d1d1d' }
                />
            </div>
            <span>{ title }</span>
        </button>
    )
};

export default PaymentTab;
